// @flow
import React from 'react';
import {
  useCustomValidation,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { RowContext } from '../grid.js';
import { types as t } from '../validation/runtime-checks/index.js';
import Figure from '../Figure.js';

type Props = {|
  videoId: string,
|};

const width = 596;
const height = 360;

export default function WistiaVideo(props: Props) {
  const { failedValidation } = usePropsValidation(props, WistiaVideo);
  const { pixelWidth } = React.useContext(RowContext);

  const { failedValidation: failedCustomValidation } = useCustomValidation(
    props,
    (addErrors, locations) => {
      if (width != null && width > pixelWidth)
        addErrors([
          {
            message: `Videos should have at least ${width}px wide containers. Container width: ${pixelWidth}`,
            ...locations.WistiaVideo,
          },
        ]);
    },
  );

  if (failedValidation || failedCustomValidation) return null;
  return (
    <Figure>
      <div style={{ textAlign: 'center' }}>
        <iframe
          src={makeIframeUrl({
            id: props.videoId,
          })}
          height={height}
          width={width}
          title="Wistia video player"
          frameBorder="0"
          scrolling="no"
          allowFullScreen
        />
      </div>
    </Figure>
  );
}

WistiaVideo.spec = {
  videoId: t.string,
};

function makeIframeUrl({ id }: {| id: string |}): string {
  return (
    'https://fast.wistia.net/embed/iframe/' + // eslint-disable-line prefer-template
    id +
    `?autoplay=false` +
    `&controlsVisibleOnLoad=true` +
    `&fullscreenButton=true` +
    `&playButton=true` +
    `&playerColor=0875BE`
  );
}
